import { Component, OnInit } from '@angular/core';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

import { ThemeService } from './shared/theme.service';
import { environment } from 'src/environments/environment';

declare var gtag: Function | undefined;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'aiii-med';
  private routerSubscription!: Subscription;

  constructor(
    private router: Router,
    private themeService: ThemeService,
    private firestore: Firestore,
  ) {}

  ngOnInit(): void {
    this.initGA4();
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.initializeTheme();
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private initGA4(): void {
    if (environment.ga4MeasurementId && typeof gtag === 'undefined') {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.ga4MeasurementId}`;
      document.head.appendChild(script);

      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).gtag = function () {
        (window as any).dataLayer.push(arguments);
      };
      (window as any).gtag('js', new Date());
      (window as any).gtag('config', environment.ga4MeasurementId, { send_page_view: false });
    }
  }

  private async initializeTheme(): Promise<void> {
    const url = new URL(window.location.href);
    const site = url.searchParams.get('site');

    if (site) {
      const siteDocRef = doc(this.firestore, 'sites', site);
      const docSnapshot = await getDoc(siteDocRef);

      const theme = docSnapshot.get('medOption.liffConfig.theme');
      if (theme) {
        this.themeService.setTheme(theme);
      }
    }
  }
}
